import { fetch } from '@financial-tool/fetch';
import { CashFlow, CashFlowBody } from '../types/cashFlow';

export default function getCashFlowAPI(cashflow: CashFlowBody) {
  return fetch.get<CashFlow>(
    `/cashflow?startDate=${cashflow.periodStart}&endDate=${cashflow.periodEnd}`,
  );
}
